/* eslint-disable linebreak-style */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable import/extensions */

import React from 'react';
import { Fade } from 'react-awesome-reveal';
import { useLanguage } from '../contexts/LanguageContext.js';

export default function VisiMisi() {
  const { t } = useLanguage();

  return (
    <section className="container mx-auto py-16 px-4">
      <div
        className="rounded-2xl py-12 px-8"
        style={{ backgroundColor: "rgba(249,250,251,0.8)" }}
      >
        <Fade direction="up" triggerOnce>
          <h2 className="text-4xl font-bold text-center text-black mb-12">
            {t('visionMissionTitle')}
          </h2>
        </Fade>

        <div className="space-y-8">
          {/* Visi */}
          <Fade direction="up" triggerOnce delay={300}>
            <div className="bg-white rounded-xl p-6 shadow-lg">
              <h3 className="text-2xl font-bold text-black mb-4 text-center">
                {t('vision')}
              </h3>
              <p className="text-green-900 text-base leading-relaxed text-center font-semibold">
                {t('visionText2')}
              </p>
            </div>
          </Fade>

          {/* Misi */}
          <Fade direction="up" triggerOnce delay={500}>
            <div className="bg-white rounded-xl p-6 shadow-lg">
              <h3 className="text-2xl font-bold text-black mb-4 text-center">
                {t('mission')}
              </h3>
              <ul className="text-black text-lg leading-relaxed space-y-2 font-semibold">
                <li>• {t('missionPoint1')}
                <p className="text-green-900 text-base font-medium">
                  {t('missionPoint1Desc')}
                </p>
                </li>
                <li>• {t('missionPoint2')}
                <p className="text-green-900 text-base font-medium">
                  {t('missionPoint2Desc')}
                </p>
                </li>
                <li>• {t('missionPoint3')}
                <p className="text-green-900 text-base font-medium">
                  {t('missionPoint3Desc')}
                </p>
                </li>
                <li>• {t('missionPoint4')}
                <p className="text-green-900 text-base font-medium">
                 {t('missionPoint4Desc')}
                </p>
                </li>
                <li>• {t('missionPoint5')}
                <p className="text-green-900 text-base font-medium">
                 {t('missionPoint5Desc')}
                </p>
                </li>
              </ul>
            </div>
          </Fade>
        </div>

        {/* Nilai-nilai Perusahaan */}
        <Fade direction="up" triggerOnce delay={700}>
          <div className="mt-12 bg-white rounded-xl p-6">
            <h3 className="text-2xl font-bold text-black mb-6 text-center">
              {t('companyValues')}
            </h3>
            <div className="grid md:grid-cols-3 gap-6">
              <div className="text-center">
                <div 
                  className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-3"
                  style={{ 
                    backgroundImage: "url('/assets/images/about/light-bulb.png')",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                  }}
                />
                <h4 className="font-semibold text-black mb-2">{t('innovation')}</h4>
                <p className="text-green-900 text-sm">{t('innovationDesc')}</p>
              </div>
              <div className="text-center">
                <div 
                  className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-3"
                  style={{ 
                    backgroundImage: "url('/assets/images/about/badge.png')",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                  }}
                />
                <h4 className="font-semibold text-black mb-2">{t('quality')}</h4>
                <p className="text-green-900 text-sm">{t('qualityDesc2')}</p>
              </div>
              <div className="text-center">
                <div 
                  className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-3"
                  style={{ 
                    backgroundImage: "url('/assets/images/about/planet-earth.png')",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                  }}
                />
                <h4 className="font-semibold text-black mb-2">{t('sustainability')}</h4>
                <p className="text-green-900 text-sm">{t('sustainabilityDesc')}</p>
              </div>
            </div>
          </div>
        </Fade>
      </div>
    </section>
  );
}
